import { Route } from 'react-router-dom';
import HomePage from '../component/homePage';
import ClientSys from '../component/clientSys/routes';
import Wei from '../component/weitoubao';
import React from 'react';
import Loadable from 'react-loadable';
import Errors from '../component/error';
import Authority from '../component/authority';

import ExportFile from '../component/policySys/export-file';
import Content from '../component/common/content';

/**
 * 根据状态展示加载页面
 * @param isLoading     加载中
 * @param error         加载错误
 * @returns {*}         html
 * @constructor
 */
const MyLoadingComponent = ({ isLoading, error }) => {
    if (error) {
        //错误页面
        return (
            <div>
                <Errors />
            </div>
        );
    } else {
        return null;
    }
};
// /** 首页*/
// const AsyncHomePage = Loadable({
//   loader: () => import('../component/homePage'),
//   loading: MyLoadingComponent
// });
/** 基本法*/
const AsyncLaws = Loadable({
    loader: () => import('../component/law/lawRoute'),
    loading: MyLoadingComponent,
});

const AsyncOrgManager = Loadable({
    loader: () => import('../component/orgManager/routes'),
    loading: MyLoadingComponent,
});
/** 产品管理*/
const AsyncProductSys = Loadable({
    loader: () => import('../component/productSys/routes'),
    loading: MyLoadingComponent,
});
/** 订单管理*/
const AsyncProposalSys = Loadable({
    loader: () => import('../component/proposalSys/routes'),
    loading: MyLoadingComponent,
});
/** 保单管理*/
const AsyncPolicySys = Loadable({
    loader: () => import('../component/policySys/routes'),
    loading: MyLoadingComponent,
});
/** 费用管理*/
const AsyncFeeSys = Loadable({
    loader: () => import('../component/feeSys/routes'),
    loading: MyLoadingComponent,
});
// /** 客户管理*/
// const AsyncClientSys = Loadable({
//   loader: () => import('../component/clientSys/routes'),
//   loading: MyLoadingComponent
// });
/** 组织机构*/
const AsyncCompany = Loadable({
    loader: () => import('../component/companymanager/company'),
    loading: MyLoadingComponent,
});
/** 继续率统计*/
const AsyncPersistRate = Loadable({
    loader: () => import('../component/persistRate/route'),
    loading: MyLoadingComponent,
});
/** 系统管理*/
const AsyncSystem = Loadable({
    loader: () => import('../component/system/system'),
    loading: MyLoadingComponent,
});
/** 考勤统计*/
const AsyncAttendances = Loadable({
    loader: () => import('../component/attendance/router'),
    loading: MyLoadingComponent,
});

/** 线下保单*/
const AsyncOfflinePolicy = Loadable({
    loader: () => import('../component/offlinePolicy/router'),
    loading: MyLoadingComponent,
});
/** 业务统计*/
const AsyncBusinessReport = Loadable({
    loader: () => import('../component/businessReport/router'),
    loading: MyLoadingComponent,
});
/** 电子台账*/
const AsyncFinance = Loadable({
    loader: () => import('../component/finance/routes.js'),
    loading: MyLoadingComponent,
});
// /* 微投保 */
// const Weitoubao = Loadable({
//   loader:() => import('../component/weitoubao/index'),
//   loading:MyLoadingComponent
// });
/* 财务结算（钱包功能） */
const FinanceSettle = Loadable({
    loader: () => import('../component/financeSettle/route'),
    loading: MyLoadingComponent,
});
/*商城管理*/
const AsyncShopSys = Loadable({
    loader: () => import('../component/shopSys/routes.js'),
    loading: MyLoadingComponent,
});

/** 财务结算*/
const AsyncSettlement = Loadable({
    loader: () => import('../component/settlement/settlement.js'),
    loading: MyLoadingComponent,
});
/** 产品维护*/
const AsyncProductMaintain = Loadable({
    loader: () => import('../component/productMaintain/routes'),
    loading: MyLoadingComponent,
});
/** 泰合登陆页面*/
const AsyncTaiheLogin = Loadable({
    loader: () => import('../component/login/index_v4_general'),
    loading: MyLoadingComponent,
});
const AsyncOrnization = Loadable({
    loader: () => import('../component/orgnization/route'),
    loading: MyLoadingComponent,
});
const AsyncActivities = Loadable({
    loader: () => import('../component/activity/route'),
    loading: MyLoadingComponent,
});
const groupInsSys = Loadable({
    loader: () => import('../component/groupIns/route'), //loader: () => import('../component/groups/routes'),
    loading: MyLoadingComponent,
});

// /** 组织机构*/
// const AsyncGroup2 = Loadable({
//   loader: () => import('../component/companymanager/groupManger2'),
//   loading: MyLoadingComponent
// });

const preservationSys = Loadable({
    loader: () => import('../component/preservationSys/routes'),
    loading: MyLoadingComponent,
});
const transformingAndTrading = Loadable({
    loader: () => import('../component/transformingAndTrading/route'),
    loading: MyLoadingComponent,
});
const continueRate = Loadable({
    loader: () => import('../component/continueRate/route'),
    loading: MyLoadingComponent,
});

const exportFileCom = () => {
    return (
        <div style={{ minHeight: '100%', display: 'flex', flex: 1 }}>
            <Content padding="0" marginTop="0" background="#f0f2f5">
                <ExportFile />
            </Content>
        </div>
    );
};

// const exportFile = Loadable({
//   loader: ()=>import('../component/policySys/export-file'),
//   loading: MyLoadingComponent
// })

const routerMaps = [
    <Route key={1} exact path="/" component={HomePage} />,
    <Route key={5} exact path="/homePage" component={HomePage} />,
    <Route key={6} path="/laws" component={AsyncLaws} />,
    <Route key={7} path="/orgManager" component={AsyncOrgManager} />,
    <Route key={8} path="/productSys" component={AsyncProductSys} />,
    <Route key={9} path="/proposalSys" component={AsyncProposalSys} />,
    <Route key={10} path="/policySys" component={AsyncPolicySys} />,
    <Route key={11} path="/feeSys" component={AsyncFeeSys} />,
    <Route key={12} path="/clientSys" component={ClientSys} />,
    <Route key={13} path="/company" component={AsyncCompany} />,
    <Route key={14} path="/persist" component={AsyncPersistRate} />,
    <Route key={15} path="/system" component={AsyncSystem} />,
    <Route key={16} path="/attendance" component={AsyncAttendances} />,
    <Route key={17} path="/offlinePolicy" component={AsyncOfflinePolicy} />,
    <Route key={18} path="/businessReport" component={AsyncBusinessReport} />,
    <Route key={19} path="/finance" component={AsyncFinance} />,
    <Route key={20} path="/settlement" component={AsyncSettlement} />,
    <Route key={21} path="/weitoubao" component={Wei} />,
    <Route key={22} path="/financeSettle" component={FinanceSettle} />,
    <Route key={23} path="/shopSys" component={AsyncShopSys} />,
    <Route key={24} path="/productMaintain" component={AsyncProductMaintain} />,
    <Route key={25} exact path="/login_g/:id?" component={AsyncTaiheLogin} />,
    <Route key={26} path="/orgnization" component={AsyncOrnization} />,
    <Route key={27} path="/activity" component={AsyncActivities} />,
    <Route key={28} path="/groupIns" component={groupInsSys} />,
    <Route key={29} path="/preservationSys" component={preservationSys} />,
    <Route key={30} path="/transformingAndTrading" component={transformingAndTrading} />,
    <Route key={31} path="/continueRate" component={continueRate} />,
    <Route key={32} path="/export/exportFile" component={exportFileCom} />,
    <Route key={33} path="/authority" component={Authority} />,
];
export default routerMaps;
